import { render, staticRenderFns } from "./PromptFormSVG.vue?vue&type=template&id=74d8fc5a"
import script from "./PromptFormSVG.vue?vue&type=script&lang=ts"
export * from "./PromptFormSVG.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports